/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import './window.abtest.utils';
import { appConfig } from '../appConfig';
import { UserType } from '../microApps/common/flow/user/userModels';
import { hybrisUserQueryKeys } from '../microApps/common/hooks/useUserQueries';
import { coopQueryClient } from '../microApps/common/init/coopQueryClient';
import { PriceType } from '../microApps/common/models/priceData/priceData';
import persistance from '../microApps/common/persistance/persistance';
import store from '../microApps/common/store';
import { cartEditOrderActions } from '../microApps/common/store/slices/cart/cartEditOrderSlice';
import { debugActions } from '../microApps/common/store/slices/ui/debugSlice';
import { sharedUiActions } from '../microApps/common/store/slices/ui/sharedUiSlice';
import { municipalUserInfoActions } from '../microApps/common/store/slices/user/municipalUserInfoSlice';
import { punchoutQueryKeys } from '../microApps/ecommerce/hooks/usePunchoutOrgUnit';
import { isDevelopmentEnvironment, isProductionEnvironment } from './environments';

window.console.logDev = (...params) => {
    if (isDevelopmentEnvironment) {
        console.log(...params);
    }
};

window.console.logNotProd = (...params) => {
    if (!isProductionEnvironment) {
        console.log(...params);
    }
};

window.console.errorDev = (...params) => {
    if (isDevelopmentEnvironment) {
        console.error(...params);
    }
};

window.console.logOnlyInEditMode = (...params) => {
    if (window.epi?.inEditMode) {
        console.log(...params);
    }
};

// This code will not be available in production builds
if (!isProductionEnvironment) {
    window.mockMunicipalUI = (
        firstName: string = 'Firstname',
        lastName: string = 'Lastname',
        comments: string = 'comments',
    ) => {
        coopQueryClient.setQueryData(hybrisUserQueryKeys.municipal(), () => ({
            firstName,
            lastName,
            commentAboutCustomer: comments,
            municipalityCode: '345',
            municipalityUnitCode: '123',
        }));

        store.dispatch(municipalUserInfoActions.mockShoppingForAnother());
    };

    window.mockEditOrderUI = () => {
        store.dispatch(cartEditOrderActions.mock());
    };

    window.mockPunchoutUI = (orgUnitName: string = 'Awesome Punchout Customer') => {
        coopQueryClient.setQueryData(hybrisUserQueryKeys.type(), () => UserType.punchout);
        coopQueryClient.setQueryData(punchoutQueryKeys.orgUnit, () => ({
            orgUnit: {
                uid: '123',
                name: orgUnitName,
                agreementId: '',
                gln: '',
            },
        }));
        store.dispatch(debugActions.setBool({ key: 'mockUserIsPunchout', value: true }));
    };

    (window as any).addProductsInDocument = () => {
        Array.from(
            document.querySelectorAll<HTMLElement>(
                '[data-testid="product-card"] button[data-testid="add_to_cart_button"]',
            ),
        ).forEach((item) => item.click());
    };
}

(window as any).setPriceType = (priceType: PriceType) => {
    const userId = appConfig.coopUserSettings.shoppingUserId;

    if (priceType === PriceType.IncludeTax) {
        persistance.priceTypeStorage.setPricesWithTax(userId);
        store.dispatch(sharedUiActions.setPriceType({ preferredPriceType: PriceType.IncludeTax }));
        console.log(
            'Prices switched to IncludeTax. Switch only for presentation purposes. For proper testing, use B2C user.',
        );
    }

    if (priceType === PriceType.ExcludeTax) {
        persistance.priceTypeStorage.setPricesWithoutTax(userId);
        store.dispatch(sharedUiActions.setPriceType({ preferredPriceType: PriceType.ExcludeTax }));
        console.log(
            'Prices switched to ExcludeTax. Switch only for presentation purposes, APIs might not return some B2B prices when B2C user is used. For proper testing, use B2B user.',
        );
    }
};

(window as any).toggleCoopDevTools = () => {
    window.dispatchEvent(new Event('toggleCoopDevTools'));
};

(window as any).setExcludeTaxPriceType = () => {
    (window as any).setPriceType('ExcludeTax');
};

(window as any).setIncludeTaxPriceType = () => {
    (window as any).setPriceType('IncludeTax');
};

(window as any).getRenderedSSRprops = () => {
    return Array.from(document.querySelectorAll<HTMLElement>('[data-react-props]'))
        .filter((node) => !!node.dataset?.reactProps)
        .map((node) => JSON.parse(node.dataset.reactProps!));
};

(window as any).trackActiveElement = (time: number = 500) => {
    setInterval(() => {
        console.log(document.activeElement);
    }, time);
};

(window as any).getServerData = () => {
    console.log(
        'Server data from DOM:',
        Array.from(document.getElementsByClassName('js-serverData')).map((node) => ({
            node,
            dataset: (node as HTMLElement).dataset,
            data: JSON.parse(node.innerHTML),
        })),
    );
};

if (!isProductionEnvironment) {
    (window as any).getServerData();
}
